import { FC } from 'react';
import { Box, HStack, Tag, Text } from '@chakra-ui/react';

type Props = {
  heading: string;
  tag?: string;
};

const ProposalCard: FC<Props> = ({ heading, tag, children }) => {
  return (
    <Box overflow='hidden' borderRadius='xl' borderWidth={1}>
      <Box bg='gray.800' py={4} px={6}>
        <HStack>
          <Text fontWeight='600' fontSize='lg'>
            {heading}
          </Text>
          {tag && <Tag borderRadius='full'>{tag}</Tag>}
        </HStack>
      </Box>
      <Box p={6} bg='gray.900'>
        {children}
      </Box>
    </Box>
  );
};

export default ProposalCard;
